module.exports = __webpack_public_path__ + "product/product-step@2x-91574eade02e2fad58c88dda7b65f3d9.webp";